import React, { useCallback } from 'react';
import { GlyphSeries, LineSeries } from '@visx/xychart';
import GlyphLineSeriesModel from "../../models/series/GlyphLineSeriesModel.js";
import { GlyphRendererFactory } from "../Factory.js";
export default function GlyphLineSeries(props) {
  const {
    dataKey,
    data,
    xAccessor,
    yAccessor,
    strokeOpacity,
    curve,
    model
  } = props;
  const glyphModel = GlyphLineSeriesModel.getGlyph(model);
  const renderGlyph = useCallback(glyphProps => {
    return GlyphRendererFactory.create(glyphModel, {
      ...glyphProps
    });
  }, [glyphModel]);
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(LineSeries, {
    dataKey: dataKey,
    data: data,
    xAccessor: xAccessor,
    yAccessor: yAccessor,
    strokeOpacity: strokeOpacity,
    curve: curve
  }), /*#__PURE__*/React.createElement(GlyphSeries, {
    dataKey: dataKey,
    data: data,
    xAccessor: xAccessor,
    yAccessor: yAccessor,
    renderGlyph: renderGlyph
  }));
}